import { IdentityProviders } from '@backstage/core-components';
import { microsoftAuthApiRef } from '@backstage/core-plugin-api';

const AZURE_ENABLED_HOSTS = [
  // TODO: Refactor into config
  'backstage-kingpin-ui-dev.apps.dapt.to',
  'backstage-cf-dev.apps.dapt.to',
  'backstage-upgrade-scheduler-dev.apps.dapt.to',
];

let providers: IdentityProviders = [
  {
    id: 'azure-auth-provider',
    title: 'Azure',
    message: "Authenticate using Apptio's Azure SSO",
    apiRef: microsoftAuthApiRef,
  },
];

function skipAuth(baseUrl: string): boolean {
  // Subset of conditions of skipAuth in plugins/ldap-backend/src/service/helpers.ts (can't cross-import)
  const hostname = new URL(baseUrl).hostname;
  if (AZURE_ENABLED_HOSTS.includes(hostname)) {
    return false;
  }
  return Boolean(
    hostname == 'localhost' || // Local
      (hostname.startsWith('backstage-') && hostname.endsWith('.apps.dapt.to')), // WIP Branch
  );
}

if (skipAuth(window.location.href)) {
  providers.unshift('guest');
}

export { providers };
